"use strict";
var ACC;
ACC.video = {
	/* Requires jQuery
	 * Finds and binds functionality to <picture> tags that should activate videos in a lightbox. */

	_autoload: [
		"cacheElements",
		"init",
        ["initEditorialVideo", $(".video--editorial").length],
		"bindEditorialVideo"
	],

	// Populate on the fly for cached elements such as multiple use jQuery look-ups.
	_cache: {
		id: "", // Contains current video ID (set in AV.load)
		player: null // Gets replaced when we open a new modal
	},

	// Add your constants here.
	_constants: {
		ARIA_EXPANDED: "aria-expanded",
		CLASS_OVERLAY: "overlay",
		CSS_CLASS_CLOSE_BUTTON: "close",
		CSS_CLASS_CONTENT: "content",
		CSS_CLASS_OPEN: "open",
		CSS_CLASS_VIDEO_VISIBLE: "ready",
		CONTROL_ATTRIBUTE: "aria-controls", // Attribute on activator that contains ID for area to open/close.
		DATA_VIDEO_ID: "video",
		MODAL_CONTAINER_ID: "modalVideoContainer",
		MODAL_PLAYER_ID: "modalVideoPlayer",
		SELECTOR_MODAL_ACTIVATOR: "[data-node='videoactivator']",
		SELECTOR_MODAL_VIDEO: ".video-wrapper picture",
		SELECTOR_VIDEO_WRAPPER: ".video-wrapper"

	},


	// Helper to set overlays and controls based on playing state
	setEditorialVideoState: function(video, isPlaying) {
		const container = video.closest('.video--editorial');
		const clickOverlay = container.querySelector('.video__click-overlay');
		const playOverlay = container.querySelector('.video__overlay');

		if (ACC.video.isIos()){
			if (isPlaying) {
				if (playOverlay) playOverlay.classList.add('u-hide');
				
				// iOS-specific styles for the click overlay when video is playing
				if (clickOverlay){
                    clickOverlay.style.clipPath = 'polygon(0px 0px, 100% 0px, 100% 100%, 0px 100%, 0px 0px, 28% 75%, 85% 65%, 60% 25%, 0px 45%)';
                    clickOverlay.style.display = 'unset';
                    clickOverlay.style.top = '22px';
                    clickOverlay.style.height = 'calc(100% - 38%)';
                    clickOverlay.style.bottom = '25px';
                }
				video.setAttribute('controls', '');
		} else {
			if (clickOverlay) clickOverlay.style.clipPath = 'unset';
			if (clickOverlay) clickOverlay.style.display = 'block';
			if (playOverlay) playOverlay.classList.remove('u-hide');
			video.removeAttribute('controls');
		}
	}
	else {
		if (isPlaying) {
			if (clickOverlay) clickOverlay.style.display = 'none';
			if (playOverlay) playOverlay.classList.add('u-hide');
			video.setAttribute('controls', '');
		} else {
			if (clickOverlay) clickOverlay.style.display = 'block';
			if (playOverlay) playOverlay.classList.remove('u-hide');
			video.removeAttribute('controls');
		}
	}
	},

	// Helper functions to detect mobile devices

    isAndroid: function() {
        return /Android/i.test(navigator.userAgent);
    },

	isIos: function() {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    },

	initEditorialVideo() {
		const videoContainers = document.querySelectorAll('.video--editorial');
		videoContainers.forEach(container => {
			const video = container.querySelector('.video__src');
			// Desktop: normal click overlay logic
			video.addEventListener('pause', () => {
				ACC.video.setEditorialVideoState(video, false);
			});
			video.addEventListener('play', () => {
				ACC.video.setEditorialVideoState(video, true);
			});

			// Mobile: add touchend overlay for pause when playing only in Android
            if (ACC.video.isAndroid()) {
                video.addEventListener('touchend', function(e) {
                    e.preventDefault();
                    // Only trigger pause if video is playing
                    if (!video.paused) {
                        video.pause();
                    }
					else {
						video.play();
					}
                });
            }
		});
	},

	playEditorialVideo: function(event) {
		const videoContainer = event.target.closest('.video--editorial');
		const video = videoContainer.querySelector('.video__src');
		if (video.paused) {
			video.play();
		} else {
			video.pause();
		}
	},

    playVideo: function(event) {
        const videoContainer = event.target.closest(".video");
        const video = videoContainer.querySelector(".video__src");
        const playIcon = videoContainer.querySelector(".video__control--play");
        const pauseIcon =videoContainer.querySelector(".video__control--pause");

        if (!video.paused) {
            pauseIcon.classList.add('u-hide');
            pauseIcon.setAttribute('aria-hidden', 'true');
            playIcon.classList.remove('u-hide');
            playIcon.setAttribute('aria-hidden', 'false');
            playIcon.focus({ preventScroll: true });
            video.pause();
        } else {
            pauseIcon.classList.remove('u-hide');
            pauseIcon.setAttribute('aria-hidden', 'false');
            pauseIcon.focus({ preventScroll: true });
            playIcon.classList.add('u-hide');
            playIcon.setAttribute('aria-hidden', 'true');
            video.play();
        }
    },

	handleVideoEnd: function(event) {
		const videoContainer = event.target.closest(".video");
		const playIcon = videoContainer.querySelector(".video__control--play");
		const pauseIcon = videoContainer.querySelector(".video__control--pause");

		playIcon.classList.remove('u-hide');
		playIcon.setAttribute('aria-hidden', 'false');
		pauseIcon.classList.add('u-hide');
		pauseIcon.setAttribute('aria-hidden', 'true');
	},

	cacheElements: function() {
		var AV = ACC.video;
		var cache = AV._cache;
		var c = AV._constants;
		cache.$videos = $(c.SELECTOR_MODAL_VIDEO);
		cache.$activators = $(c.SELECTOR_MODAL_ACTIVATOR);
		cache.$container = this.createModalContainer();
		cache.$content = this.createContentContainer();
		cache.$overlay = this.createOverlay();

		// Add new elements to the DOM.
		cache.$container.append(cache.$overlay);
		cache.$container.append(cache.$content);
		$(document.body).append(cache.$container);
	},

	init: function() {
		var AV = ACC.video;
		var cache = AV._cache;

		// If we have found modal videos or some activators...
		if(cache.$videos.length || cache.$activators.length) {
			this.setupModalVideos();
			this.setupApi();
			this.setupLinks();

			$(window).on("resize", function() {
				ACC.video.resize();
			});
		}
	},

	bindEditorialVideo: function() {
        $(".video--editorial").on("click", function() {
            ACC.common.getParameterByVideoClick(".video--editorial");
        });
    },

	// Create the modal elements required to support the Lightbox videos
	createModalContainer: function() {
		var AV = ACC.video;
		var cache = AV._cache;
		var c = AV._constants;
		var $container = $("<div></div>");
		var closeElements = "." + c.CLASS_OVERLAY + ", ." + c.CSS_CLASS_CLOSE_BUTTON;
		$container.attr("id", c.MODAL_CONTAINER_ID);
		$container.on("click", closeElements, function() {
			cache.player.stopVideo();
			AV.close();
		});
		return $container;
	},

	// Create the target element that is replaced with YouTube iframe.
	createPlayerTarget: function() {
		var AV = ACC.video;
		var c = AV._constants;
		var $player = $("<div></div>");
		$player.attr("id", c.MODAL_PLAYER_ID);
		return $player;
	},

	// Create the inner content container (wraps close button and iframe)
	createContentContainer: function() {
		var AV = ACC.video;
		var c = AV._constants;
		var $content = $("<div></div>");
		$content.addClass(c.CSS_CLASS_CONTENT);
		$content.append(AV.createCloseButton());
		$content.append(AV.createPlayerTarget());
		return $content;
	},

	// Create a close button for the lightbox
	createCloseButton: function() {
		var AV = ACC.video;
		var c = AV._constants;
		var $button = $("<button><i aria-hidden=\"true\" class=\"icon icon-cancel\"></i></button>");
		$button.attr("aria-label", "Close");
		$button.addClass(c.CSS_CLASS_CLOSE_BUTTON);
		return $button;
	},

	// Creates and returns a new overlay for the component.
	createOverlay: function() {
		var AV = ACC.video;
		var c = AV._constants;
		var $overlay = $("<div></div>");
		$overlay.addClass(c.CLASS_OVERLAY);
		return $overlay;
	},

	// Cache videos and bind click events to activate Lightbox functionality.
	setupModalVideos: function() {
		var AV = ACC.video;
		var cache = AV._cache;
		var c = AV._constants;

		cache.$videos.add(cache.$activators).each(function() {
			var $this = $(this);
			$this.attr(c.CONTROL_ATTRIBUTE, c.MODAL_CONTAINER_ID);
			$this.parent('.video-wrapper').on("click", function() {
				AV.activateLightboxVideo($this.data(c.DATA_VIDEO_ID));
			});
		});
	},

	// Making the button clickable to make it open category urls
	setupLinks: function() {
		$('.link-activator').each(function() {
			var $this = $(this);
			$this.unbind().on("click", function() {
				window.location.href = $(this).attr('data-href');
			});
		});
	},

	// If we have modal videos present we need to get the API.
	setupApi: function() {
		var AV = ACC.video;
		var cache = AV._cache;
		if(cache.$videos.length) {
			ACC.global.addYouTubeApi("ACC.video.create");
		}
	},

	// Create a new iframe for the video specified by ID.
	// @id (String) YouTube video ID value.
	create: function(id) {
		var AV = ACC.video;
		var cache = AV._cache;
		var c = AV._constants;
		cache.player = new YT.Player(c.MODAL_PLAYER_ID, {
			videoId: (id || cache.$videos.length ? cache.$videos.data(c.DATA_VIDEO_ID) : "unknown"),
			playerVars: {
				modestbranding: 1,
				width: '100%',
				autoplay: 0,
				autohide: 0,
				controls: 1,
				enablejsapi: 1,
				rel: 0,
				showinfo: 0
			}
		});
	},

	// Activate the lightbox functionality to play video.
	// @id (String) YouTube video ID value.
	activateLightboxVideo: function(id) {
		var AV = ACC.video;
		var cache = AV._cache;
		AV.resize();
		AV.load(cache.player, id);
		AV.open();
	},

	// Set Player size by finding the maximum that can fit the screen.
	// Based on playback quality sizes stated on https://developers.google.com/youtube/iframe_api_reference
	resize: function() {
		var AV = ACC.video;
		var cache = AV._cache;
		var width = $(window).width();
		var height = $(window).height();
		var $iframe = $(cache.player.getIframe());
		var sizes = [
			[320, 240],   // small
			[640, 360],   // medium
			[853, 480],   // large
			[1280, 720],  // hd720
			[1920, 1080] // hd1080
		];

		var i = 0;
		var size, iHeight;

		do {
			size = sizes[i];
			i++;
		} while(i<sizes.length && (sizes[i][0] <= width && sizes[i][1] <= height));

		// Resize the player iframe
		cache.player.setSize.apply(cache.player, size);

		// Adjust the iframe margin-top to suit new size.
		iHeight = Math.floor((height - $iframe.height()) / 4);
		if(iHeight > 0) {
			cache.$content.css("margin-top", String(iHeight > 0 ? iHeight : 0) + "px");
		}
	},

	// Load a new video (by id) into the player
	// @player (YT.Player) Target YouTube player instance.
	// @id (String) Required YouTube video id.
	load: function(player, id) {
		if(player && id) {
			ACC.video._cache.id = id;
			player.loadVideoById(id);
		}
	},

	// Closes the modal container element.
	close: function() {
		var AV = ACC.video;
		var cache = AV._cache;
		var c = AV._constants;
		cache.$container.removeClass(c.CSS_CLASS_VIDEO_VISIBLE);
		cache.$overlay.fadeOut(150, function() {
			cache.$container.attr(c.ARIA_EXPANDED, false);
			cache.$container.removeClass(c.CSS_CLASS_OPEN);
			ACC.global.enableScroll();
		});
	},

	// Opens the modal container element.
	open: function() {
		var AV = ACC.video;
		var cache = AV._cache;
		var c = AV._constants;
		ACC.global.disableScroll();
		cache.$container.attr(c.ARIA_EXPANDED, true);
		cache.$container.addClass(c.CSS_CLASS_OPEN);
		cache.$overlay.fadeIn(250, function() {
			cache.$container.addClass(c.CSS_CLASS_VIDEO_VISIBLE);
		});
	}
};